<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="'修改价格'"></el-page-header>
		<el-form label-position="right" :model="item" label-width="auto">
			<el-table style="margin-bottom: 22px; margin-top:0;" :data="item" border tooltip-effect="dark">
				<el-table-column label="商品规格" prop="sku_name" align="center"></el-table-column>
				<el-table-column label="销售价（元）">
					<template slot-scope="scope">
						<el-input v-model="scope.row.price"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="成本价（元）">
					<template slot-scope="scope">
						<el-input v-model="scope.row.cost"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="市场价（元）">
					<template slot-scope="scope">
						<el-input v-model="scope.row.market_price"></el-input>
					</template>
				</el-table-column>
			</el-table>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				pirceArr:[]
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			loadData: function() {
				// 获取商品信息
				this.axios.get('/store/product/detail', {
					params: {
						id: this.id
					}
				}).then(res => {
					this.item = res.data.detail.sku
				})
			},
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.item.forEach((res,index) => {
					this.pirceArr.push({
						skuName:res.sku_name,
						unique:res.unique,
						price:parseFloat(res.price),
						cost:parseFloat(res.cost),
						market_price:parseFloat(res.market_price)
					})
				})
				this.axios.put('/store/product/updateSku', {
					sku: this.pirceArr,
					id: this.id
				})
				.then(() => {
					this.isLoad = false
					this.$message.success({
						message: '保存成功'
					});
					this.goBack()
				})
				.catch(() => {
					this.isLoad = false
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			}
		}
	}
</script>
<style scoped>
</style>
